import { FormatHelper } from "../Helpers/FormatHelper.js";

export class TextWidget {
    constructor(app, vehicle, containerElement) {
        this.app = app;
        this.vehicle = vehicle;
        this.paymentData = null;
        this.containerElement = containerElement || null;
    }

    init(paymentData) {
        paymentData = paymentData || this.paymentData;
        if (!paymentData) return;

        this.paymentData = paymentData;
        this.addHtml();
    }

    addHtml() {
        var isCash = this.paymentData.dealType === 'cash';
        //cash: pm-drs-api computes this total (finalPriceDisplay, payment + doc fee) for
        //every engine, every request — matches the VDP tabs widget and deal page, which
        //fold the same doc fee in instead of understating it.
        var priceValue = isCash ? (this.paymentData.finalPriceDisplay ?? this.paymentData.payment) : this.paymentData.monthlyPayment;
        var subTitle = isCash ? this.app.pmdrs.dataDriver.getCashPriceLabel() : '';

        var template = `<div class="text-widget {{class}}">
    <span class="text-widget-subtitle">{{subTitle}}</span>
    <span class="text-widget-monthly"><span class="monthly-payment-value">{{monthlyPayment}}</span><span class="text-widget-mo-suffix">/mo estimated</span>
        <span class='drs-tooltip'><i class='pmdrs-fa pmdrs-fa-info-circle'></i>
            <span class='drs-tooltiptext-large' style="font-size: 14px;">
                {{disclaimer}}
            </span>
        </span>
    </span>
    <span class="text-widget-cash-down"><span class="cash-down-value">{{cashDown}}</span> cash down</span>
</div>
`;
        template = template
            .replaceAll("{{class}}", `tw-item-${this.paymentData.dealType}`)
            .replaceAll("{{subTitle}}", subTitle)
            .replaceAll("{{monthlyPayment}}", FormatHelper.currencyFormat(priceValue, 0))
            .replaceAll("{{cashDown}}", FormatHelper.currencyFormat(this.paymentData.dueAtSign ?? 0, 0))
            .replaceAll("{{disclaimer}}", this.paymentData.disclaimerText || this.getDefaultDisclaimer(isCash));

        const container = this.getContainerElement();
        if (!container) return;

        container.querySelectorAll('.text-widget').forEach(el => el.remove());
        container.insertAdjacentHTML("beforeend", template);
    }

    getDefaultDisclaimer(isCash) {
        if (isCash) {
            return `Price excludes applicable taxes, title, registration,
            license, and documentary fees, and will vary depending upon the final price
             agreed upon between you and your dealer.`;
        }
        return `Estimated payments exclude applicable taxes, title, registration,
        license, and documentary fees, and will vary depending upon the final price
         and terms agreed upon between you and your dealer.`;
    }

    setContainerElement(element) {
        this.containerElement = element;
        return this;
    }

    getContainerElement() {
        if (this.containerElement) return this.containerElement;
        var containerSelector = `.${this.app.config.textWidgetClass}[data-vin="${this.vehicle.vin}"]`;
        var containerElement = document.querySelector(containerSelector);
        if (!containerElement) {
            console.error("Missing container " + containerSelector);
        }
        return containerElement;
    }
}
